module.exports = __webpack_public_path__ + "static/img/detial.e65d630.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/detial.png
// module id = f8Jm
// module chunks = 0